var _path;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgCharge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.61523 19.8066H19.3965C20.9961 19.8066 22.2529 19.6309 23.1582 18.7256C24.0547 17.8203 24.2217 16.5811 24.2217 14.9814V12.3359C24.2217 10.7275 24.0547 9.48828 23.1582 8.5918C22.2441 7.68652 20.9961 7.51074 19.3965 7.51074H5.58887C4.01562 7.51074 2.75879 7.68652 1.8623 8.5918C0.957031 9.49707 0.790039 10.7363 0.790039 12.3096V14.9814C0.790039 16.5811 0.957031 17.8291 1.85352 18.7256C2.76758 19.6309 4.01562 19.8066 5.61523 19.8066ZM5.36914 18.084C4.46387 18.084 3.61133 17.9521 3.11914 17.4688C2.62695 16.9766 2.5127 16.1416 2.5127 15.2275V12.1074C2.5127 11.1846 2.62695 10.3408 3.11035 9.84863C3.60254 9.35645 4.46387 9.2334 5.38672 9.2334H19.6426C20.5566 9.2334 21.4092 9.35645 21.8926 9.84863C22.3848 10.3408 22.499 11.1758 22.499 12.0898V15.2275C22.499 16.1416 22.3848 16.9766 21.8926 17.4688C21.4092 17.9609 20.5566 18.084 19.6426 18.084H5.36914ZM5.02637 16.9766H15.5469C16.0918 16.9766 16.417 16.8975 16.6455 16.6689C16.8652 16.4404 16.9531 16.1152 16.9531 15.5791V11.7383C16.9531 11.1934 16.8652 10.8682 16.6455 10.6484C16.417 10.4199 16.0918 10.3408 15.5469 10.3408H5.04395C4.48145 10.3408 4.15625 10.4199 3.92773 10.6396C3.70801 10.8682 3.62012 11.2021 3.62012 11.7559V15.5791C3.62012 16.124 3.70801 16.4404 3.92773 16.6689C4.15625 16.8975 4.48145 16.9766 5.02637 16.9766ZM25.5049 16.0361C26.2344 15.9922 27.21 15.0605 27.21 13.6543C27.21 12.2568 26.2344 11.3164 25.5049 11.2725V16.0361Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharge);
export default __webpack_public_path__ + "static/media/charge.bb88e329adb874c350efebbcdf80a91b.svg";
export { ForwardRef as ReactComponent };